import { dateFromString as i, getLastDayOfMonth as a } from "../../utils/date.es.js";
import { padWithZero as f } from "../../utils/number.es.js";
const s = (r) => /^([1-9]\d{3})-\d{1,2}-\d{1,2}$/.test(r), u = (r, e) => {
  if (r === "single") {
    const { date: t } = e ?? {};
    if (t && s(t))
      return [i(t)];
  }
  if (r === "range") {
    const { startDate: t, endDate: n } = e ?? {};
    if (t && n && s(t) && s(n))
      return [i(t), i(n)];
  }
  return [];
}, D = (r, e) => {
  if (r === "single" && e) {
    const { date: t } = e;
    if (t && s(t))
      return i(t);
  }
  if (r === "range" && e) {
    const { startDate: t } = e;
    if (t && s(t))
      return i(t);
  }
  return /* @__PURE__ */ new Date();
}, $ = (r, e, t) => r < e ? e : r > t ? t : r, d = ({ year: r, month: e, day: t = 1 }, n = !1) => {
  const o = a(r, e);
  return n && t > o ? `${r}-${f(e)}-${f(o)}` : `${r}-${f(e)}-${f(t)}`;
};
export {
  d as getDateString,
  D as getInitialOffset,
  u as getInitialValue,
  $ as getOffsetDate,
  s as isValidDate
};
//# sourceMappingURL=DatePicker.utils.es.js.map
